import styled from 'styled-components'

export const SortableRefundMethodContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp16};

  #draggable-icon {
    flex-shrink: 0;
    margin-top: ${props => props.theme.spacing.sp16};
    cursor: ${props => (props.isSortable ? 'grab' : 'default')};
  }

  & > div {
    flex-grow: 1;
  }
`
export const RefundMethodsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
